<template>
  <div
    id="SideBar"
    class="hidden absolute top-0 right-0 left-0 bottom-0 outline-0"
  >
    <PromotionDetailsModal
      :show="promotionDetailsModal.show"
      modal-id="modalPromotionDetails"
      modal-class="modalPromotionDetails superimpose"
      :message="getPromotionDetailsText()"
      @close-modal="closePromotionDetails"
    />

    <div
      @click="closeMenu()"
      class="overlay z-30 w-full h-full bg-black-full"
    ></div>
    <div
      id="sideContent"
      class="
        absolute
        z-30
        top-0
        w-full
        md:w-87
        h-full
        bg-white
        pt-18
        md:pt-13
        duration-300
        ease-in
        right-0
      "
      :key="$store.getters.uuidShoppingCartComponent"
    >
      <div class="uppercase py-4 mb-4 bg-yellow-photo font-semibold">
        <div class="font-bold px-4">{{ $t("cart.check_order") }}</div>
        <div
          @click="closeMenu()"
          class="absolute right-0 top-1 p-2 cursor-pointer"
        >
          <span class="close material-icons"> close </span>
        </div>
      </div>

      <div class="shoppingCart" v-if="Object.keys($store.state.shoppingCart || {}).length > 0">
        <div
          class="item border-t border-yellow-photo"
          v-for="(item, index) in $store.state.shoppingCart"
          :key="index"
        >    
                
          <!-- Video Sale -->
          <div class="flex mx-2 px-2 py-3 relative" v-if="item.type == 3">
           
            <img              
              :src="GetLogoSrc(item.VideoDetails.parkId)"
              :alt="item.VideoDetails.parkId"
              class="w-1/5 logo"
            />            

            <div class="flex flex-col flex-auto justify-center px-2">
              <span class="font-bold uppercase mb-1">
                {{ item.Name }}
              </span>
              <div class="flex text-xs">
                <div class="flex flex-col flex-auto">
                  <span> {{ $t("gallery.tag") }} {{ FormatCartTags(item.Tags) }} </span>
                  <span>
                    {{ $tc("messages.videos", item.TotalMedia) }}
                  </span>
                  <span class="dateString">
                    {{ dateString(item.date) }}
                  </span>
                </div>
                <span class="flex font-semibold items-end">
                  {{ item.Amount | toCurrency }}
                  {{ $store.state.Currency }}
                </span>
              </div>
            </div>
            <div
              @click.prevent="
                $store.dispatch('removeParkFromShoppingCart', index)
              "
              class="
                flex
                absolute
                right-0
                top-0
                p-2
                cursor-pointer
                items-center
              "
            >
              <span class="material-icons"> delete </span>
            </div>
          </div>

          <!-- Codigos de Descarga -->
          <template v-else-if="item.type == 0">
            <div class="flex px-4 text-sm mt-2">
              <span class="font-bold mr-1">{{ $t("gallery.code") }}</span>
              {{ item.code }} |
              {{ $tc("messages.albumes", item.Parks.length) }}
            </div>
            <div
              v-if="item.IsPromotionManualPending"
              class="promotion-cart-message"
            >
              <span>{{ getIncompletePromotionMessage(item) }}</span>
              <button
                type="button"
                class="promotion-cart-message__link"
                @click.stop.prevent="openPromotionDetails(item)"
              >
                {{ $t("messages.promotion_see_more") }}
              </button>
            </div>

            <div
              v-for="group in getAlbumDisplayGroups(item)"
              :key="`download-group-${item.code}-${group.groupNumber}`"
              class="border-t border-yellow-photo"
            >
              <div
                class="flex mx-2 px-2 py-3 relative"
                v-for="(item2, idx2) in group.parks"
                :key="`${group.groupNumber}-${item2.Park.Id}-${idx2}`"
              >
                <img
                  :src="$S3AssetUrl('/suf/logos/min/hotel-' + item2.Park.Id + '.png')"
                  class="imgCut w-1/5"
                  v-if="item2.Park.IsHotel"
                />
                <img
                  :src="$S3AssetUrl('/suf/logos/min/parque-' + item2.Park.Id + '.png')"
                  class="imgCut w-1/5"
                  v-else
                />

                <div class="flex flex-col flex-auto justify-center px-2">
                  <span class="font-bold uppercase mb-1">
                    {{ $t("gallery.fotos") }} {{ getParkName(item2.Park.Id) }}
                  </span>
                  <div class="flex text-xs">
                    <div class="flex flex-col flex-auto">
                      <span>{{ item2.TotalMedia }} {{ $t("gallery.fotos") }}</span>
                      <span class="dateString">{{ dateString(item.date) }}</span>
                    </div>
                    <span
                      v-if="isIncludedAlbumInGroup(group, item2)"
                      class="flex font-semibold items-end"
                    >
                      {{ $t("gallery.AddedByPromotion") }}
                    </span>
                    <span v-else class="flex font-semibold items-end">
                      {{ getAlbumParkDisplayPrice(item, group, item2) | toCurrency }}
                      {{ $store.state.Currency }}
                    </span>
                  </div>
                  <div
                    v-if="canRemoveAlbum(item2, group)"
                    @click.prevent="
                      $store.dispatch('removeShoppingCartByDownloadCode', {
                        park: item2,
                        idx: idx2,
                        code: item.code
                      })
                    "
                    class="flex absolute right-0 top-0 p-2 cursor-pointer items-center"
                  >
                    <span class="material-icons"> delete </span>
                  </div>
                </div>
              </div>

              <div
                v-if="getAlbumDisplayGroups(item).length > 1"
                class="flex px-4 pb-2 text-xs font-bold"
              >
                <span class="flex-auto">{{ $t("cart.subtotal") }}:</span>
                <span>{{ group.subtotal | toCurrency }} {{ $store.state.Currency }}</span>
              </div>
            </div>
          </template>

          <!-- Room -->
          <template v-else-if="item.type == 2">
            <div class="flex px-4 text-sm mt-2">
              <span class="font-bold mr-1">{{ $t("cart.room") }}</span>
              {{ item.Room }} |
              {{ $tc("messages.albumes", item.Parks.length) }}
            </div>
            <div
              v-if="item.IsPromotionManualPending"
              class="promotion-cart-message"
            >
              <span>{{ getIncompletePromotionMessage(item) }}</span>
              <button
                type="button"
                class="promotion-cart-message__link"
                @click.stop.prevent="openPromotionDetails(item)"
              >
                {{ $t("messages.promotion_see_more") }}
              </button>
            </div>

            <div
              v-for="group in getAlbumDisplayGroups(item)"
              :key="`room-group-${item.Room}-${group.groupNumber}`"
              class="border-t border-yellow-photo"
            >
              <div
                class="flex mx-2 px-2 py-3 relative"
                v-for="(item2, idx2) in group.parks"
                :key="`${group.groupNumber}-${item2.Park.Id}-${idx2}`"
              >
                <img
                  :src="$S3AssetUrl('/suf/logos/min/hotel-' + item2.Park.Id + '.png')"
                  class="imgCut w-1/5"
                  v-if="item2.Park.IsHotel"
                />
                <img
                  :src="$S3AssetUrl('/suf/logos/min/parque-' + item2.Park.Id + '.png')"
                  class="imgCut w-1/5"
                  v-else
                />

                <div class="flex flex-col flex-auto justify-center px-2">
                  <span class="font-bold uppercase mb-1">
                    {{ $t("gallery.fotos") }} {{ getParkName(item2.Park.Id) }}
                  </span>

                  <div class="flex text-xs">
                    <div class="flex flex-col flex-auto">
                      <span>{{ item2.TotalMedia }} {{ $t("gallery.fotos") }}</span>
                      <span class="dateString">{{ dateString(item.date) }}</span>
                    </div>

                    <span
                      v-if="isIncludedAlbumInGroup(group, item2)"
                      class="flex font-semibold items-end"
                    >
                      {{ $t("gallery.AddedByPromotion") }}
                    </span>
                    <span v-else class="flex font-semibold items-end">
                      {{ getAlbumParkDisplayPrice(item, group, item2) | toCurrency }}
                      {{ $store.state.Currency }}
                    </span>
                  </div>
                </div>

                <div
                  v-if="canRemoveAlbum(item2, group)"
                  @click.prevent="
                    $store.dispatch('removeShoppingCartByRoom', {
                      park: item2,
                      idx: idx2,
                      room: item.Room
                    })
                  "
                  class="flex absolute right-0 top-0 p-2 cursor-pointer items-center"
                >
                  <span class="material-icons"> delete </span>
                </div>
              </div>

              <div
                v-if="getAlbumDisplayGroups(item).length > 1"
                class="flex px-4 pb-2 text-xs font-bold"
              >
                <span class="flex-auto">{{ $t("cart.subtotal") }}:</span>
                <span>{{ group.subtotal | toCurrency }} {{ $store.state.Currency }}</span>
              </div>
            </div>
          </template>

          <!-- Regular Park -->
          <div class="flex mx-2 px-2 py-3 relative" v-else>
            <img
              :src="$S3AssetUrl('/suf/logos/min/parque-' + item.ParkId + '.png')"
              :alt="item.ParkId"
              class="w-1/5"
            />
            <div class="flex flex-col flex-auto justify-center px-2">
              <span class="font-bold uppercase mb-1" v-if="item.ServiceId != null">
                {{ item.Name }}
              </span>
              <span class="font-bold uppercase mb-1" v-else>
                {{ $t("gallery.fotos") }}
                {{ getParkName(item.ParkId) }}
              </span>

              <div class="flex text-xs">
                <div class="flex flex-col flex-auto">
                  <template v-if="item?.AlbumMode != 1">
                    <span v-if="item.Pax">{{ $tc("messages.pax", item.Pax) }}</span>
                    <span v-else>{{ $tc("messages.albumes", item.cantidad) }}</span>
                  </template>
                  <span>{{ item.TotalMedia }} {{ $t("gallery.fotos") }}</span>
                  <span class="dateString">{{ dateString(item.date) }}</span>
                </div>
                <span class="flex font-semibold items-end">
                  {{ item.Amount | toCurrency }}
                  {{ $store.state.Currency }}
                </span>
              </div>
            </div>
            
            <div
              @click.prevent="
                $store.dispatch('removeParkServiceIdFromShoppingCart', { park: item.park, tag: item.uuid })
              "
              class="
                flex
                absolute
                right-0
                top-0
                p-2
                cursor-pointer
                items-center
              "
              v-if="item.ServiceId != null"
            >
              <span class="material-icons"> delete </span>
            </div>
            <div
              @click.prevent="item?.AlbumMode === 1
                ? removeItemFromCardByIndividual({
                    parkId: item.ParkId,
                    cartKey: item.CartKey,
                    albumKeyId: item.AlbumKeyId,
                  })
                : $store.dispatch('removeParkFromShoppingCart', index)"
              class="
                flex
                absolute
                right-0
                top-0
                p-2
                cursor-pointer
                items-center
              "
              v-else
            >
              <span class="material-icons"> delete </span>
            </div>
          </div>
        </div>

        <div
          class="flex flex-col items-end pt-3 border-t border-yellow-photo mx-4"
        >
          <div class="flex flex-col w-4/5">
            <div class="flex text-sm hidden">
              <span class="flex-auto">Subtotal:</span>
              <span>$ 1,737.54 MXN</span>
            </div>
            <div
              class="
                flex
                font-bold
                pb-3
                mb-4
                border-b border-yellow-photo
                text-sm
              "
            >
              <span class="flex-auto">Total:</span>
              <span
                >{{ $store.state.payment.Amount | toCurrency }}
                {{ $store.state.Currency }}
              </span>
            </div>
            <div class="flex flex-auto justify-center items-center">
              <img
                class="paymentMethods flex flex-col flex-auto justify-center"
                alt="VISA"
                title="VISA"
                :src="$S3AssetUrl('suf/payments/payment-methods/vi.svg')"
              />
              <img
                class="paymentMethods flex flex-col flex-auto justify-center"
                alt="Mastercard"
                title="Mastercard"
                :src="$S3AssetUrl('suf/payments/payment-methods/mc.svg')"
              />
              <img
                class="paymentMethods flex flex-col flex-auto justify-center"
                alt="American Express"
                title="American Express"
                :src="$S3AssetUrl('suf/payments/payment-methods/ax.svg')"
              />
              <img
                class="paymentMethods flex flex-col flex-auto justify-center"
                alt="PayPal"
                title="PayPal"
                :src="$S3AssetUrl('suf/payments/payment-methods/pp.svg')"
              />
            </div>
            <p class="w-full text-xs mb-4">
              {{ $t("cart.banks_cards") }}
              <a class="text-link-blue" target="_blank" :href="$t('cart.main_cards_href')">{{ $t("cart.cards") }}</a>
            </p>
            <br />
            <a
              @click.prevent="payNow()"
              id="paymentLink"
              class="
                w-3/4
                text-center
                p-2
                bg-red-600
                text-white
                rounded-full
                text-sm
                cursor-pointer
              "
              v-if="$store.state.payment.Amount"
            >
              {{ $t("cart.pay") }}
            </a>
            <!-- <button @click="$store.dispatch('clearShoppingCart')">Limpiar carrito</button> -->
          </div>
        </div>
      </div>
      <p class="shopping-cart-empty" v-else>
        <center>
          <img
            :src="$S3AssetUrl('suf/payments/shopping-cart-empty.webp')"
            alt=""
          />
          <br />
          {{ $t("cart.no_products") }}
        </center>
      </p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions } from 'vuex';
import ShoppingCartMx from "./mixins/ShoppingCart";
import CartMix from "./mixins/Cart";
import MenuMix from "./mixins/Menu";
import ShoppingCartItems from "./store/shoppingCartItemsComponent.vue";
import {
  GetPromotionPendingMessageContext as GetPromotionPendingMessageContextHelper,
  GetPromotionPendingRemaining as GetPromotionPendingRemainingHelper,
  GetPromotionDetailsMessageContext as GetPromotionDetailsMessageContextHelper,
} from "../helpers/promotionMessageHelper";
import PromotionDetailsModal from "./Modals/PromotionDetailsModal.vue";

export default {
  mixins: [ShoppingCartMx, CartMix, MenuMix],
  components: {
    ShoppingCartItems,
    PromotionDetailsModal,
  },
  data: () => ({
    uuid: "",
    renderComponent: true,
    ShoppingCart: {},
    GetShoppingCart: {},
    promotionDetailsModal: {
      show: false,
      item: null,
    },
    createdOn: Date.now() + "-" + Math.random().toString(36).substring(2, 5),
  }),
  methods: {
    ...mapActions('individualSales', ['addCartByIndividual', 'removeItemFromCardByIndividual']),
    /**
     * Formats video tags for the cart summary.
     *
     * @param {Array<string>|string|null} value Video tag value.
     * @returns {string} Comma-separated unique tags.
     */
    FormatCartTags(value) {
      const source = Array.isArray(value)
        ? value
        : value
          ? [value]
          : [];

      return [...new Set(
        source
          .map((tag) => String(tag || "").trim())
          .filter(Boolean)
      )].join(", ");
    },
    updateShoppingCart() {},
    payNow() {
      if (this.hasIncompletePromotionCart()) {
        const pendingItem = this.getIncompletePromotionItem();

        this.$toast.open({
          message: this.getIncompletePromotionMessage(pendingItem),
          type: "info",
        });
        this.openPromotionDetails(pendingItem);
        return;
      }

      this.closeMenu();
      this.$router.push({ name: "payment" });
    },
    getAlbumDisplayGroups(item) {
      if (Array.isArray(item?.DisplayGroups) && item.DisplayGroups.length) {
        return item.DisplayGroups;
      }

      const parks = Array.isArray(item?.Parks) ? item.Parks : [];

      return [
        {
          groupNumber: 1,
          parks,
          paidParks: parks.filter((park) => !this.isIncludedAlbum(park)),
          includedParks: parks.filter((park) => this.isIncludedAlbum(park)),
          subtotal: Number(item?.Amount || 0),
          paidUnitPrice: Number(item?.NormalIndividual || 0),
        },
      ];
    },
    isIncludedAlbum(park) {
      return !!(
        park?.WasAutoAddedByPromotion || park?.WasIncludedByPromotion
      );
    },
    isIncludedAlbumInGroup(group, park) {
      const parkId = Number(park?.Park?.Id);
      const includedParks = Array.isArray(group?.includedParks)
        ? group.includedParks
        : [];

      if (includedParks.length) {
        return includedParks.some((includedPark) => {
          return Number(includedPark?.Park?.Id) === parkId;
        });
      }

      return this.isIncludedAlbum(park);
    },
    canRemoveAlbum(park, group = null) {
      return !this.isIncludedAlbumInGroup(group, park);
    },
    getAlbumParkDisplayPrice(item, group, park) {
      if (item?.IsOnlyHotel) {
        return Number(park?.Amount || item?.NormalIndividual || 0);
      }

      return Number(
        group?.paidUnitPrice || item?.NormalIndividual || item?.Amount || 0
      );
    },
    hasIncompletePromotionCart() {
      return Object.values(this.$store.state.shoppingCart || {}).some(
        (item) => item?.IsPromotionManualPending
      );
    },
    getIncompletePromotionItem() {
      return Object.values(this.$store.state.shoppingCart || {}).find(
        (item) => item?.IsPromotionManualPending
      );
    },
    GetPromotionPendingRemaining(item) {
      return GetPromotionPendingRemainingHelper(item || this.getIncompletePromotionItem());
    },
    /**
     * Gets the translated cart warning shown when free promotion albums are
     * still pending before payment.
     *
     * @param {Object|null} item Cart item to evaluate.
     * @returns {string} Translated pending promotion message.
     */
    getIncompletePromotionMessage(item = null) {
      const messageContext = GetPromotionPendingMessageContextHelper(
        item || this.getIncompletePromotionItem()
      );

      return this.$tc(
        messageContext.key,
        messageContext.choice,
        messageContext.params
      );
    },
    openPromotionDetails(item) {
      this.promotionDetailsModal = {
        show: true,
        item,
      };
    },
    closePromotionDetails() {
      this.promotionDetailsModal = {
        show: false,
        item: null,
      };
    },
    /**
     * Gets the translated detail text for the reusable promotion modal.
     *
     * @returns {string} Translated promotion detail message.
     */
    getPromotionDetailsText() {
      const messageContext = GetPromotionDetailsMessageContextHelper(
        this.promotionDetailsModal.item || this.getIncompletePromotionItem()
      );

      return this.$t(messageContext.key, messageContext.params);
    },
    GetPrice(item) {
      
      return new Promise((res, rej) => {
        axios
          .post("/api/payment/GetNewPrice", {
            data: {
              ServiceNumber: item.cantidad,
              ParkId: item.ParkId,
            },
          })
          .then((result) => {
            this.ShoppingCart = result.data;

            res();
          })
          .catch(() => rej());
      });
    },
    CheckIsHotel(id) {
      if(id == 8 || id == 11 || id == 14)      
        return true;
    },
    GetLogoSrc(parkId) {
      const type = this.CheckIsHotel(parkId) ? 'hotel' : 'parque';
      return this.$S3AssetUrl(`suf/logos/min/${type}-${parkId}.png`);
    },
    async forceRerender() {
      
      // Remove my-component from the DOM
      this.renderComponent = false;
      await this.$nextTick();
    }
  },
  watch: {},
  computed: {},
  updated() {},
  watch: {},
  created() {},
  mounted() {
    this.uuid = localStorage.getItem("uuid");
    
    this.createdOn =
      Date.now() + "-" + Math.random().toString(36).substring(2, 5);
  },
};
</script>


